// this component was automatically generated by IconGlyph.template.js
import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useFeatureGate } from '@trello/feature-gate-client';
import { useLazyComponent } from '@trello/use-lazy-component';

import { Icon } from '../components/Icon';
import type { Color, GlyphProps } from '../components/Icon/Icon.types';

const ExternalLinkIconGlyph = () => {
  return (
    <svg
      width="24"
      height="24"
      role="presentation"
      focusable="false"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.745 8.6082C10.742 8.0352 11.204 7.5722 11.776 7.5722H11.78L15.941 7.5912C16.515 7.5942 16.983 8.0622 16.986 8.6362L17.005 12.7972C17.006 13.3712 16.543 13.8352 15.969 13.8322C15.394 13.8302 14.926 13.3622 14.924 12.7882L14.9163 11.0759L8.19297 17.7992C7.80197 18.1892 7.16797 18.1892 6.77797 17.7992C6.38797 17.4092 6.38797 16.7752 6.77797 16.3842L13.5013 9.66089L11.789 9.6532C11.215 9.6512 10.747 9.1832 10.745 8.6082Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ExternalLinkIcon: FunctionComponent<GlyphProps> = (props) => {
  const { testId, dangerous_className, size, color, label, block } = props;
  const { value: isIconFlagEnabled } = useFeatureGate('trello_ads_icons');

  const LazyAdsIcon = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "ADS-ExternalLinkIcon" */ '@atlaskit/icon/core/link-external'
      ),
    { namedImport: 'default', preload: false },
  );

  const adsIconSize = size === 'medium' || size === 'small' ? size : undefined;

  return isIconFlagEnabled ? (
    <span className={dangerous_className}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-ghost',
          feature: 'ADS Icon',
        }}
      >
        <ChunkLoadErrorBoundary fallback={null}>
          <Suspense fallback={null}>
            <LazyAdsIcon
              label={label || ''}
              testId={testId || 'ExternalLinkIcon'}
              color={color as Color}
              size={adsIconSize}
            />
          </Suspense>
        </ChunkLoadErrorBoundary>
      </ErrorBoundary>
    </span>
  ) : (
    <Icon
      testId={testId || 'ExternalLinkIcon'}
      size={size}
      dangerous_className={dangerous_className}
      color={color}
      block={block}
      label={label}
      glyph={ExternalLinkIconGlyph}
    />
  );
};
